import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute() {
  const { user, booting, loading } = useAuth();
  const isChecking = booting || loading;

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white font-bold text-sm">
        Verifying admin privileges…
      </div>
    );
  }

  // Redirect to user dashboard if not logged in or not an admin
  const isAdmin = Boolean(user && (user.is_admin || user.role === "admin"));
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}